<template>
  <div class="tabs">
    <nav :aria-label="ariaLabel">
      <ul role="tablist" :class="{ 'tabs-stretched': isStretched }">
        <li
          v-for="tab in tabs"
          :key="tab.tabId"
          :ref="tab.isActive ? 'activeTab' : null"
          role="tab"
          :aria-selected="tab.isActive ? 'true' : 'false'"
          :class="{ 'tab-selected': tab.isActive }"
          :tabindex="tab.isActive ? 0 : -1"
          @keydown="onKeyDown($event, tab)"
          @click="selectTab(tab)"
        >
          {{ tab.label }}
        </li>
      </ul>
    </nav>

    <div class="tab-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * If true, the tabs will stretch to fill the container
     */
    isStretched: {
      required: false,
      type: Boolean
    },
    /**
     * Used for accessibility for nav element
     */
    ariaLabel: {
      required: true,
      type: String
    }
  },
  data() {
    return { tabs: [] }
  },
  created() {
    this.tabs = this.$children
  },
  mounted() {
    this.tabs[0].isActive = true
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.tabId === selectedTab.tabId
        if (tab.isActive) {
          this.$nextTick(() => this.$refs.activeTab[0].focus())
        }
      })
    },
    onKeyDown(e, tab) {
      const tabIndex = this.tabs.indexOf(tab)
      if (e.keyCode === 39) {
        // If we're at the end, go to the start
        if (tabIndex >= this.tabs.length - 1) {
          this.selectTab(this.tabs[0])
        } else {
          this.selectTab(this.tabs[tabIndex + 1])
        }
        // Move left
      } else if (e.keyCode === 37) {
        // If we're at the start, move to the end
        if (tabIndex === 0) {
          this.selectTab(this.tabs[this.tabs.length - 1])
        } else {
          this.selectTab(this.tabs[tabIndex - 1])
        }
      }
    }
  }
}
</script>

<style lang="scss">
.tabs {
  transition-duration: 0.25s;
  transition-property: background-color, box-shadow, color, fill;
  width: 100%;

  nav {
    display: flex;

    ul {
      border-left: 1px solid $grey;
      display: inline-flex;
      padding: 0;

      &.tabs-stretched {
        flex-grow: 1;
      }
      li {
        background-color: $grey-light;
        border: 1px solid $grey;
        border-left: 0;
        color: $grey-darker;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 1px;
        line-height: 30px;
        margin-bottom: 0;
        padding: 0 15px;
        text-align: center;
        text-transform: uppercase;
        white-space: nowrap;
        width: 100%;

        &:hover {
          background-color: $grey-1;
          color: $grey-darker;
        }

        &.tab-selected {
          background-color: $white;
          border-bottom: none;
          color: black;
        }
      }
    }
  }

  .tab-content {
    border: 1px solid $grey;
    margin-top: -1px;
    text-align: left;
  }
}
</style>
